export default {
  TNC_ERROR:
    'Sie müssen zunächst die Allgemeinen Geschäftsbedingungen und die Datenschutzrichtlinie von Fielddrive akzeptieren, um sich anzumelden.',
  WELCOME_BACK: 'Willkommen zurück! Sie haben sich erfolgreich eingeloggt.',
  TNC_LABEL: 'Durch Ankreuzen dieses Kästchens stimmen Sie den Fielddrive Leads zu',
  TNC: 'Allgemeine Geschäftsbedingungen',
  TNC_LINK: 'https://www.fielddrive.com/terms-and-conditions',
  LOWER_AND: 'und',
  POLICY: 'Datenschutzrichtlinien',
  POLICY_LINK: 'https://www.fielddrive.com/privacy-policy',
  POLICY_LABEL: 'Sie ermächtigen Fielddrive Leads, Ihre personenbezogenen Daten für die darin angegebenen Zwecke zu verarbeiten.',
  LOGIN: 'Anmelden'
}
